<template>
  <b-card bg-variant="light">
    <h4 :class="'mb-4'+ sign.message !== '' ? 'is-invalid':''">Je n'ai pas encore de compte</h4>
    <div class="invalid-feedback">{{ sign.message }}</div>
    <b-form ref="signInForm" @submit.stop.prevent @submit="SignIn" novalidate autocomplete="off">
      <b-form-group>
        <b-form-input placeholder="Prenom" v-model="sign.prenom" required></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input placeholder="Pays" v-model="sign.pays" required></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input placeholder="Email" v-model="sign.mail" type="email" required></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input placeholder="Mot de Passe"
                      v-model="sign.password"
                      type="password"
                      required
                      pattern=".{6,}"></b-form-input>
        <div class="invalid-feedback">
          Ton mot de passe doit contenir au moins 6 caractères.
        </div>
      </b-form-group>
      <b-btn variant="primary" type="submit">Je m'inscris</b-btn>
    </b-form>
    <hr>
    <h4 :class="'mb-4' + invalid !== '' ? 'is-invalid':''">J'ai déjà un compte</h4>
    <div class="invalid-feedback">{{ invalid }}</div>
    <b-form @submit.stop.prevent @submit="LogIn" class="is-invalid">
      <b-form-group>
        <b-form-input placeholder="Email" v-model="log.mail" type="email"></b-form-input>
      </b-form-group>
      <b-form-group class="is-invalid">
        <b-form-input placeholder="Mot de Passe" v-model="log.password"
                      type="password"></b-form-input>
      </b-form-group>

      <router-link to="/reset">Mot de Passe Oublie?</router-link>
      <b-btn variant="primary" type="submit">Je me connecte</b-btn>
    </b-form>
  </b-card>
</template>

<script>
import {Auth} from "@/js/caller";

export default {
  name: "LandingAuth",
  data() {
    return {
      sign   : {
        prenom  : "",
        pays    : "",
        mail    : "",
        password: "",
        message : "",
      },
      log    : {
        mail    : "",
        password: "",
      },
      invalid: ""
    }
  },
  methods: {
    LogIn() {
      Auth
          .LogIn(this.log)
          .then((res) => {
            if (!res?.error) return this.$router.push('/');
            this.invalid = res.error
          });
    },
    SignIn() {
      const form = this.$refs.signInForm;
      if (!form.checkValidity()) return form.classList.add('was-validated');
      Auth
          .SignIn(this.sign)
          .then((res) => {
            if (!res?.error) return this.$router.push('/');
            this.sign.message = res.error;
          })
    },
  },
}
</script>

<style scoped>
a {
  display: block;
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
}
</style>